import caching from "@/plugins/caching/caching";

export default {
    install(Vue) {
        Vue.prototype.$caching = new caching('cachingDB');
    }
}